import type { OpenAnswerQuestion, SingleAnswerQuestion } from '@feh/shared-ui';
import { createReducer, on } from '@ngrx/store';

import { homebatteryQuestionnaireStructure } from './homebattery-questionnaire-old.structure';
import {
  initializeQuestionnaire,
  loadNextQuestion,
  loadPreviousQuestion,
  submitQuestionnaireAnswer,
} from './homebattery-questionnaire.actions';
import * as NewFlow from './homebattery-questionnaire.structure';

export const homebatteryQuestionnaireKey = 'homebattery-questionnaire';

type HomebatteryQuestionnaireQuestion =
  | SingleAnswerQuestion
  | OpenAnswerQuestion;

export type HomebatteryQuestionnaireState = {
  structure: { [key: string]: HomebatteryQuestionnaireQuestion };
  currentQuestion: HomebatteryQuestionnaireQuestion;
  answers: { [key: string]: string | number | boolean | null };
  history: HomebatteryQuestionnaireQuestion[];
};

export const initialState: HomebatteryQuestionnaireState = {
  structure: homebatteryQuestionnaireStructure,
  currentQuestion: homebatteryQuestionnaireStructure['hasSolarPanels'],
  answers: {},
  history: [],
};

export const homebatteryQuestionnaireReducer = createReducer(
  initialState,
  on(initializeQuestionnaire, (_, { useNewFlow }) =>
    useNewFlow
      ? {
          ...initialState,
          structure: NewFlow.homebatteryQuestionnaireStructure,
          currentQuestion:
            NewFlow.homebatteryQuestionnaireStructure['hasEnergyContract'],
        }
      : initialState
  ),
  on(submitQuestionnaireAnswer, (state, { question, answer }) => ({
    ...state,
    answers: {
      ...state.answers,
      [question.apiKey]: typeof answer == 'object' ? answer.apiValue : answer,
    },
  })),
  on(loadNextQuestion, (state, { question }) => {
    const history = [...state.history];
    history.push(state.currentQuestion);
    return {
      ...state,
      history,
      currentQuestion: question,
    };
  }),
  on(loadPreviousQuestion, (state) => {
    const history = [...state.history];
    const previous = history.pop();
    return previous !== undefined
      ? { ...state, currentQuestion: previous, history }
      : state;
  })
);
